import { createContext, useContext, useEffect, useState } from "react";

const AdminCtx = createContext({ isAdmin: false, password: "", login: () => {}, logout: () => {} });

export const AdminProvider = ({ children }) => {
  const [password, setPassword] = useState("");

  useEffect(() => {
    const saved = localStorage.getItem("kays_admin_pwd");
    if (saved) setPassword(saved);
  }, []);

  const login = (pwd) => {
    localStorage.setItem("kays_admin_pwd", pwd);
    setPassword(pwd);
  };

  const logout = () => {
    localStorage.removeItem("kays_admin_pwd");
    setPassword("");
  };

  return (
    <AdminCtx.Provider value={{ isAdmin: !!password, password, login, logout }}>
      {children}
    </AdminCtx.Provider>
  );
};

export const useAdmin = () => useContext(AdminCtx);
